var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46,
    fill: "none",
    viewBox: "0 0 48 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60D5D5",
    d: "m11.734 10.04 2.511-1.38-1.858 1.817 6.642 1.564-6.9-.436 1.323 2.409-2.012-2.058-1.63 6.924.43-6.839-2.143 1.18 1.939-1.896L2.97 9.66l7.155.452L8.89 7.866l1.7 1.74 1.599-6.785z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.7,
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.95 32.676c.063-.291.48-.291.542 0l.597 2.78c.023.106.106.19.212.212l2.78.597c.292.063.292.479 0 .541l-2.78.597a.28.28 0 0 0-.212.213l-.597 2.78c-.063.291-.479.291-.541 0l-.597-2.78a.28.28 0 0 0-.213-.213l-2.78-.596c-.29-.063-.29-.48 0-.542l2.78-.597a.28.28 0 0 0 .213-.212z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#60D5D5",
    d: "M41.668.88c.044-.203.335-.203.379 0l.759 3.537a.19.19 0 0 0 .148.148l3.536.76c.204.043.204.334 0 .378l-3.536.76a.19.19 0 0 0-.148.148l-.76 3.536c-.043.203-.334.203-.378 0L40.91 6.61a.19.19 0 0 0-.148-.149l-3.536-.76c-.204-.043-.204-.334 0-.377l3.535-.76a.19.19 0 0 0 .149-.148z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.965 25.429c.017-.092.148-.092.164 0l.257 1.434c.006.032.03.058.061.066l1.256.324c.084.021.084.14 0 .161l-1.256.324a.08.08 0 0 0-.061.066l-.257 1.435c-.016.091-.147.091-.164 0l-.256-1.435a.08.08 0 0 0-.062-.066l-1.256-.324c-.083-.021-.083-.14 0-.16l1.256-.325a.08.08 0 0 0 .062-.066z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#60D5D5",
    d: "M35.299 41.154c.044-.204.334-.204.378 0l.203.942a.19.19 0 0 0 .148.149l.942.202c.204.044.204.335 0 .379l-.942.202a.19.19 0 0 0-.148.148l-.203.943c-.044.203-.334.203-.378 0l-.203-.943a.19.19 0 0 0-.148-.148l-.942-.202c-.204-.044-.204-.335 0-.379l.942-.202a.19.19 0 0 0 .148-.149z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#60D5D5",
    d: "M28.635 15.38c.044-.203.334-.203.378 0l.202.943a.19.19 0 0 0 .149.148l.942.203c.204.044.204.334 0 .378l-.942.203a.19.19 0 0 0-.149.148l-.202.942c-.044.204-.334.204-.378 0l-.203-.942a.19.19 0 0 0-.148-.148l-.942-.203c-.204-.044-.204-.334 0-.378l.942-.203a.19.19 0 0 0 .149-.148z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.758 5.062c.011-.053.086-.053.097 0l.154.713a.05.05 0 0 0 .038.038l.713.154c.053.01.053.086 0 .097l-.713.154a.05.05 0 0 0-.038.038l-.154.713c-.01.053-.086.053-.097 0l-.154-.713a.05.05 0 0 0-.038-.038l-.713-.154c-.053-.011-.053-.086 0-.097l.713-.154a.05.05 0 0 0 .038-.038z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 9.407,
    height: 9.407,
    x: 0.518,
    y: 31.832,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6606_54929",
    stdDeviation: 0.313
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 5.771,
    height: 5.771,
    x: 32.602,
    y: 39.751,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6606_54929",
    stdDeviation: 0.625
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 4.486,
    height: 4.486,
    x: 17.564,
    y: 3.772,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6606_54929",
    stdDeviation: 0.625
  })))));
};
export default SvgStars;